import { RegisterModule } from '@/typings/common'
/* eslint object-curly-newline: 0 */
import { UsersState, UsersGetters, UsersMutations, UsersActions } from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: UsersState,
    getters: UsersGetters,
    mutations: UsersMutations,
    actions: UsersActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as usersStoreModule,
  mapper as usersMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
